export default "__VITE_ASSET__CXGSuUzU__"